import { Helmet } from 'react-helmet-async'
import { ToastContainer } from 'react-toastify'

import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faTimes } from '@fortawesome/pro-light-svg-icons'

// @ts-expect-error
import { ArtworkEditor } from '@domain-group/artwork-builder'
import { getQueryParamsFromHash, parsePermittedQueryParams } from '@domain-group/javascript-utils'
import { useNumericParams } from '@domain-group/react-hooks'

import '@domain-group/artwork-builder/dist/styles.css'

import useArtworkBuilder from '../../hooks/useArtworkBuilder'

// @ts-expect-error TS7031
const CloseButton = ({ closeToast }) => (
  <a onClick={closeToast}>
    <FontAwesomeIcon icon={faTimes} />
  </a>
)

const EditPage = () => {
  const { artworkId, taskId } = useNumericParams()

  const { redirect }: { redirect?: string } = parsePermittedQueryParams(getQueryParamsFromHash(), ['redirect'])

  const artworkBuilderPayload = useArtworkBuilder({ redirect, taskListItemId: taskId, artworkId })
  const {
    callbacks: {
      deleteArtwork,
      fetchEditorOptions,
      goBack,
    },
  } = artworkBuilderPayload

  return (
    <>
      <Helmet>
        <title>Test Template | Template Manager</title>
      </Helmet>

      <ArtworkEditor
        callbacks={{
          deleteArtwork,
          fetchEditorOptions,
          goBack,
        }}
      >
        <ArtworkEditor.Header />
        <ArtworkEditor.Canvas />

        {/*
         // @ts-expect-error TS2741 */}
        <ToastContainer closeButton={<CloseButton />} hideProgressBar autoClose={5000} />
      </ArtworkEditor>
    </>
  )
}

export default EditPage
